import { deriveDisplayPrice } from "../lib/display-price";
import { useTradeMarket } from "./use-trade-market";
import { useTradeRecentTrades } from "./use-trade-recent-trades";

/**
 * The canonical "current price" for the active market — last traded price while
 * the trade feed is live, mark price when the latest trade is stale. Both the
 * orderbook center value and the browser-tab title resolve through the same
 * rule (`lib/display-price.ts`) so they never disagree.
 */
export function useDisplayPrice() {
	const { trades } = useTradeRecentTrades();
	const { marketData } = useTradeMarket();

	return deriveDisplayPrice({
		trades,
		markPrice: marketData.markPrice,
		nowMs: Date.now(),
	});
}
